import { useRef as y, useMemo as V, useEffect as p, useLayoutEffect as I, useState as M } from "react";
import { i as c, n as h } from "./const-BlLLRlwg.mjs";
function a(e) {
  const t = y(e);
  return t.current = e, V(() => Object.freeze({
    get current() {
      return t.current;
    }
  }), []);
}
function T(e, ...t) {
  var n;
  (n = e == null ? void 0 : e.addEventListener) == null || n.call(e, ...t);
}
function _(e, ...t) {
  var n;
  (n = e == null ? void 0 : e.removeEventListener) == null || n.call(e, ...t);
}
const X = (e, t) => Object.hasOwn(e, t), Y = (e, t) => {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (const [n, r] of e.entries())
    if (r !== t[n])
      return !1;
  return !0;
};
function A() {
  const e = y(!0);
  return p(() => {
    e.current = !1;
  }, []), e.current;
}
const N = c ? I : p;
function B(e, t) {
  const n = A();
  p(n ? h : e, t);
}
function P(e) {
  return typeof e == "function" && (e = e()), e;
}
function W(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function D(...e) {
  return e.length === 1 ? P(e[0]) : W(e[0], e[1]);
}
const f = /* @__PURE__ */ new Map(), g = (e, t, n, r) => {
  var l;
  const s = (l = f.get(e)) == null ? void 0 : l.get(t);
  if (!(s === void 0 || s.size === 0))
    for (const i of s)
      i !== r && i(n);
}, O = (e) => {
  e.storageArea && e.key && e.newValue && g(e.storageArea, e.key, e.newValue);
}, H = (e, t, n) => {
  c && f.size === 0 && T(globalThis, "storage", O, { passive: !0 });
  let r = f.get(e);
  r || (r = /* @__PURE__ */ new Map(), f.set(e, r));
  let s = r.get(t);
  s || (s = /* @__PURE__ */ new Set(), r.set(t, s)), s.add(n);
}, J = (e, t, n) => {
  const r = f.get(e);
  if (!r)
    return;
  const s = r.get(t);
  s && (s.delete(n), s.size === 0 && r.delete(t), r.size === 0 && f.delete(e), c && f.size === 0 && _(globalThis, "storage", O));
}, U = {
  defaultValue: null,
  initializeWithValue: !0
};
function C(e, t, n) {
  var L;
  const r = a({ ...U, ...n }), s = (u, o) => (r.current.parse ?? K)(u, o), l = (u) => (r.current.stringify ?? G)(u), i = a({
    fetchRaw: () => e.getItem(t),
    fetch: () => s(i.current.fetchRaw(), r.current.defaultValue),
    remove() {
      e.removeItem(t);
    },
    store(u) {
      const o = l(u);
      return o !== null && e.setItem(t, o), o;
    }
  }), R = A(), [d, E] = M((L = r.current) != null && L.initializeWithValue && R ? i.current.fetch() : void 0), z = a(d), S = a({
    fetch() {
      E(i.current.fetch());
    },
    setRawVal(u) {
      E(s(u, r.current.defaultValue));
    }
  });
  B(() => {
    S.current.fetch();
  }, [t]), p(() => {
    r.current.initializeWithValue || S.current.fetch();
  }, []), N(() => {
    const u = S.current.setRawVal;
    return H(e, t, u), () => {
      J(e, t, u);
    };
  }, [e, t]);
  const m = a({
    set(u) {
      if (!c)
        return;
      const o = D(u, z.current), w = i.current.store(o);
      w !== null && g(e, t, w);
    },
    delete() {
      c && (i.current.remove(), g(e, t, null));
    },
    fetch() {
      c && g(e, t, i.current.fetchRaw());
    }
  }), F = V(
    () => ({
      set: (u) => {
        m.current.set(u);
      },
      remove() {
        m.current.delete();
      },
      fetch() {
        m.current.fetch();
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return V(
    () => ({
      value: d,
      ...F
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d]
  );
}
const G = (e) => {
  if (e === null)
    return null;
  try {
    return JSON.stringify(e);
  } catch (t) {
    return console.warn(t), null;
  }
}, K = (e, t) => {
  if (e === null)
    return t;
  try {
    return JSON.parse(e);
  } catch (n) {
    return console.warn(n), t;
  }
};
let v;
try {
  v = c && !!globalThis.sessionStorage;
} catch {
  v = !1;
}
const Z = v ? (e, t) => C(sessionStorage, e, t) : (e, t) => ({ value: void 0, set: h, remove: h, fetch: h });
export {
  Z as a,
  C as b,
  _ as c,
  A as d,
  Y as e,
  B as f,
  X as h,
  T as o,
  D as r,
  a as u
};
//# sourceMappingURL=index-BqI2IZQT.mjs.map
